<template>
  <hr class="separator " style="margin-top: 1px"/>
  <div>
    <div class="custom-text">
      {{ $t('ProductUpgrade.productUpgrade') }}
    </div>
  </div>

  <el-tabs v-model="activeName" style="margin: 10px;" @tab-change="tabChange" @before-leave="beforeTabLeave">
    <el-tab-pane :label="$t('ProductUpgrade.motor')" name="motor">
      <ProductUpgrade code="motor" :name="motorName" :motorIcon="motorIcon" :loading="motorConnectLoading"
                      :connected="motorConnected" :dialogVisible='motorProgress' :percentage="percentage"
                      :configPercentage="configPercentage" :infos="motorInfo" :uploadFiles="uploadFiles"
                      :connect="connectMotor" :upgrade="upgrade" :uploadSuccess="uploadSuccess" :upgradeCancel="upgradeCancel"
                      :cancelLoading="cancelLoading" :lastFirmwareFile='motorLastFirmwareFile'
                      :lastConfigFile="motorLastConfigFile" :checkUpgrade="checkUpgrade" :clearSelectFile="clearSelectFile"
                      :upgradeCountInfo="upgradeCountInfo" :showApplyButton="showApplyButton" :applyLoading="applyLoading"
                      :applyUpgradeCount="handleApplyUpgradeCount" :upgradeCountLoaded="upgradeCountLoaded" :upgradeCompleted="motorUpgradeCompleted"
                      :check-upgrade-for-p8="checkUpgradeForP8" :hasSerialUpgrade="hasSerialUpgrade"
                      :afterVersion="motorAfterVersion"
                      @reset-upgrade-status="resetUpgradeStatus('motor')" @update:dialogVisible="val => motorProgress = val"/>
    </el-tab-pane>
    <el-tab-pane code="display" :label="$t('ProductUpgrade.dashboard')" name="display">
      <ProductUpgrade code="display" name='ProductUpgrade.dashboard' :loading="displayConnectLoading"
                      :connected="displayConnected" :percentage="percentage" :configPercentage="configPercentage"
                      :infos="displayInfo" :uploadFiles="displayUploadFiles" :dialogVisible='displayProgress'
                      :connect="connectDisplay" :upgrade="upgrade" :uploadSuccess="uploadSuccess"
                      :upgradeCancel="upgradeCancel" :cancelLoading="cancelLoading"
                      :lastFirmwareFile='displayLastFirmwareFile' :lastConfigFile="displayLastConfigFile"
                      :checkUpgrade="checkUpgrade" :clearSelectFile="clearSelectFile"
                      :upgradeCountInfo="upgradeCountInfo" :showApplyButton="showApplyButton" :applyLoading="applyLoading"
                      :applyUpgradeCount="handleApplyUpgradeCount" :upgradeCountLoaded="upgradeCountLoaded" :upgradeCompleted="displayUpgradeCompleted"
                       :check-upgrade-for-p8="checkUpgradeForP8" :hasSerialUpgrade="hasSerialUpgrade"
                      :afterVersion="displayAfterVersion"
                      @reset-upgrade-status="resetUpgradeStatus('display')" @update:dialogVisible="val => displayProgress = val"/>
    </el-tab-pane>
    <el-tab-pane code="battery" :label="$t('ProductUpgrade.battery')" name="battery">
      <ProductUpgrade code="battery" name='ProductUpgrade.battery' :loading="batteryConnectLoading"
                      :connected="batteryConnected" :percentage="percentage" :configPercentage="configPercentage"
                      :infos="batteryInfo" :uploadFiles="batteryUploadFiles" :dialogVisible='batteryProgress'
                      :connect="connectBattery" :upgrade="upgrade" :uploadSuccess="uploadSuccess"
                      :upgradeCancel="upgradeCancel" :cancelLoading="cancelLoading"
                      :lastFirmwareFile='batteryLastFirmwareFile' :lastConfigFile="batteryLastConfigFile"
                      :checkUpgrade="checkUpgrade" :clearSelectFile="clearSelectFile"
                      :upgradeCountInfo="upgradeCountInfo" :showApplyButton="showApplyButton" :applyLoading="applyLoading"
                      :applyUpgradeCount="handleApplyUpgradeCount" :upgradeCountLoaded="upgradeCountLoaded" :upgradeCompleted="batteryUpgradeCompleted"
                      :check-upgrade-for-p8="checkUpgradeForP8" :hasSerialUpgrade="hasSerialUpgrade"
                      :afterVersion="batteryAfterVersion"
                      @reset-upgrade-status="resetUpgradeStatus('battery')" @update:dialogVisible="val => batteryProgress = val"/>
    </el-tab-pane>
    <el-tab-pane v-if="showBoxTab" code="box" :label="$t('ProductUpgrade.box')" name="box">
      <ProductUpgrade code="box" name='ProductUpgrade.box' :loading="boxConnectLoading"
                      :connected="boxConnected" :percentage="percentage" :configPercentage="configPercentage"
                      :infos="boxInfo" :uploadFiles="boxUploadFiles" :dialogVisible='boxProgress'
                      :connect="connectBox" :upgrade="upgrade" :uploadSuccess="uploadSuccess"
                      :upgradeCancel="upgradeCancel" :cancelLoading="cancelLoading"
                      :lastFirmwareFile='boxLastFirmwareFile' :lastConfigFile="boxLastConfigFile"
                      :checkUpgrade="checkUpgrade" :clearSelectFile="clearSelectFile"
                      :upgradeCountInfo="upgradeCountInfo" :showApplyButton="showApplyButton" :applyLoading="applyLoading"
                      :applyUpgradeCount="handleApplyUpgradeCount" :upgradeCountLoaded="upgradeCountLoaded" :upgradeCompleted="boxUpgradeCompleted"
                      :check-upgrade-for-p8="checkUpgradeForP8" :hasSerialUpgrade="hasSerialUpgrade"
                      :afterVersion="boxAfterVersion"
                      @reset-upgrade-status="resetUpgradeStatus('box')" @update:dialogVisible="val => boxProgress = val"/>
    </el-tab-pane>
  </el-tabs>
  <PluginBox :visiable="pluginVisiable" :pluginUrl="pluginUrl" :handleClose="() => pluginVisiable = false" :plugin-status="pluginStatus">
  </PluginBox>
</template>


<script setup>

import { ElMessage} from 'element-plus';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import ProductUpgrade from '@/components/ProductUpgrade.vue';
import api from './api.js'
import { applyUpgradeCount, getUserPermissions, getSpecialAccounts, getUpgradeRulesList } from '@/api/api'
import PluginBox from '@/components/PluginBox.vue';
import { compareversions } from '@/utils/common.js'
const pluginVisiable = ref(false)
const pluginUrl = ref('')
const downloadFileFailed = ref(false)
import router from "@/router";

import i18n from "@/i18n";
const t = i18n.global.t; // 将 i18n.global.t 方法赋值给变量 t

// 导入国际化文本
const cancelLoading = ref(false)
// 新增：升级完成状态标记
const motorUpgradeCompleted = ref(false)
const displayUpgradeCompleted = ref(false)
const batteryUpgradeCompleted = ref(false)
const boxUpgradeCompleted = ref(false)
const showBoxTab = ref(true)
const displayProgress = ref(false)
const motorProgress = ref(false)
const batteryProgress = ref(false)
const boxProgress = ref(false)
const percentage = ref(0)
const configPercentage = ref(0)
const activeName = ref('motor')
// 存储升级后的版本信息
const motorAfterVersion = ref('')
const displayAfterVersion = ref('')
const batteryAfterVersion = ref('')
const boxAfterVersion = ref('')
// 用户类型状态变量
const userType = ref('')
// 控制是否使用序列号升级的标志
const hasSerialUpgrade = ref(true)
const motorName = ref('ProductUpgrade.motor')
const motorIcon = ref('mid')
const motorInfo = ref([
  { name: 'ProductUpgrade.model', key: 'code', value: '' },
  { name: 'ProductUpgrade.serialNumber', key: 'mcusncode', value: '' },
  { name: 'ProductUpgrade.firmwareVersion', key: 'softwareversion', value: '' },
  { name: 'ProductUpgrade.hardwareVersion', key: 'hardwareversion', value: '' },
  { name: 'ProductUpgrade.parameterVersion', key: 'parameterversion', value: '' },
])

const displayInfo = ref([
  { name: 'ProductUpgrade.model', key: 'code', value: '' },
  { name: 'ProductUpgrade.serialNumber', key: 'mcusncode', value: '' },
  { name: 'ProductUpgrade.firmwareVersion', key: 'softwareversion', value: '' },
  { name: 'ProductUpgrade.hardwareVersion', key: 'hardwareversion', value: '' },
])

const batteryInfo = ref([
  { name: 'ProductUpgrade.firmwareVersion', key: 'softwareversion', value: '' },
  { name: 'ProductUpgrade.hardwareVersion', key: 'hardwareversion', value: '' },
])
const boxInfo = ref([
  { name: 'ProductUpgrade.firmwareVersion', key: 'softwareversion', value: '' },
  { name: 'ProductUpgrade.hardwareVersion', key: 'hardwareversion', value: '' },
])
const motorConnected = ref(false)
const displayConnected = ref(false)
const batteryConnected = ref(false)
const boxConnected = ref(false)
const uploadFiles = ref({
  firmware: {
    name: 'ProductUpgrade.firmwareUpgrade',
    fileUrl: '',
    fileName: '',
    key: '',
    firmwareId: '',
    options: [],
    visible: true
  },
  config: {
    name: 'ProductUpgrade.parameterFileUpgrade',
    fileUrl: '',
    fileName: '',
    key: '',
    firmwareId: '',
    options: [],
    visible: true
  }
})
function resetUploadFiles () {
  uploadFiles.value = {
    firmware: {
      name: 'ProductUpgrade.firmwareUpgrade',
      fileUrl: '',
      fileName: '',
      key: '',
      firmwareId: '',
      options: [],
      visible: true
    },
    config: {
      name: 'ProductUpgrade.parameterFileUpgrade',
      fileUrl: '',
      fileName: '',
      key: '',
      firmwareId: '',
      options: [],
      visible: true
    }
  }
}

const motorConnectLoading = ref(false)
const displayConnectLoading = ref(false)
const batteryConnectLoading = ref(false)
const boxConnectLoading = ref(false)

const displayUploadFiles = ref({
  firmware: {
    name: 'ProductUpgrade.firmwareUpgrade',
    fileUrl: '',
    fileName: '',
    key: '',
    firmwareId: '',
    options: [],
    visible: true
  },
  config: {
    name: 'ProductUpgrade.imageFileUpgrade',
    fileUrl: '',
    fileName: '',
    key: '',
    firmwareId: '',
    options: [],
    visible: false
  }
})

const batteryUploadFiles = ref({
  firmware: {
    name: 'ProductUpgrade.firmwareUpgrade',
    fileUrl: '',
    fileName: '',
    key: '',
    firmwareId: '',
    options: [],
    visible: true
  }
})

function resetDisplayUploadFiles() {
  displayUploadFiles.value = {
    firmware: {
      name: 'ProductUpgrade.firmwareUpgrade',
      fileUrl: '',
      fileName: '',
      key: '',
      firmwareId: '',
      options: [],
      visible: true
    },
    config: {
      name: 'ProductUpgrade.imageFileUpgrade',
      fileUrl: '',
      fileName: '',
      key: '',
      firmwareId: '',
      options: [],
      visible: false
    }
  }
}

function resetBatteryUploadFiles() {
  batteryUploadFiles.value = {
    firmware: {
      name: 'ProductUpgrade.firmwareUpgrade',
      fileUrl: '',
      fileName: '',
      key: '',
      firmwareId: '',
      options: [],
      visible: true
    }
  }
}

const boxUploadFiles = ref({
  firmware: {
    name: 'ProductUpgrade.firmwareUpgrade',
    fileUrl: '',
    fileName: '',
    key: '',
    firmwareId: '',
    options: [],
    visible: true
  }
})

function resetBoxUploadFiles() {
  boxUploadFiles.value = {
    firmware: {
      name: 'ProductUpgrade.firmwareUpgrade',
      fileUrl: '',
      fileName: '',
      key: '',
      firmwareId: '',
      options: [],
      visible: true
    }
  }
}

// 重置升级状态的函数
function resetUpgradeStatus(deviceType = null) {
  // 根据设备类型重置相应的状态
  if (deviceType === 'motor' || deviceType === null) {
    // 重置电机升级相关状态
    uploadFiles.value.firmware.fileName = ''
    uploadFiles.value.config.fileName = ''
    // 手动设置对话框状态为关闭，确保不会出现第二个对话框
    motorProgress.value = false
    // 重置升级完成状态
    motorUpgradeCompleted.value = false
    // 清除固件ID和配置ID
    motorFirmwareId = 0
    motorConfigId = 0
    // 在用户点击完成按钮后重新连接设备
    connectMotor()
  }
  
  if (deviceType === 'display' || deviceType === null) {
    // 重置仪表升级相关状态
    displayUploadFiles.value.firmware.fileName = ''
    displayUploadFiles.value.config.fileName = ''
    // 手动设置对话框状态为关闭，确保不会出现第二个对话框
    displayProgress.value = false
    // 重置升级完成状态
    displayUpgradeCompleted.value = false
    // 清除固件ID和配置ID
    displayFirmwareId = 0
    displayconfigId = 0
    // 在用户点击完成按钮后重新连接设备
    connectDisplay()
  }
  
  if (deviceType === 'battery' || deviceType === null) {
    // 重置电池升级相关状态
    batteryUploadFiles.value.firmware.fileName = ''
    // 手动设置对话框状态为关闭，确保不会出现第二个对话框
    batteryProgress.value = false
    // 重置升级完成状态
    batteryUpgradeCompleted.value = false
    // 清除固件ID
    batteryFirmwareId = 0
    // 在用户点击完成按钮后重新连接设备
    connectBattery()
  }
  
  if (deviceType === 'box' || deviceType === null) {
    // 重置盒子升级相关状态
    boxUploadFiles.value.firmware.fileName = ''
    // 手动设置对话框状态为关闭，确保不会出现第二个对话框
    boxProgress.value = false
    // 重置升级完成状态
    boxUpgradeCompleted.value = false
    // 清除固件ID
    boxFirmwareId = 0
    // 在用户点击完成按钮后重新连接设备
    connectBox()
  }
  
  // 重置进度条
  percentage.value = 0
  configPercentage.value = 0
}

let motorFirmwareId = 0;
let motorConfigId = 0;
let displayFirmwareId = 0
let displayconfigId = 0
let batteryFirmwareId = 0
let boxFirmwareId = 0

const motorLastFirmwareFile = ref('')
const motorLastConfigFile = ref('')
const displayLastFirmwareFile = ref('')
const displayLastConfigFile = ref('')
const batteryLastFirmwareFile = ref('')
const batteryLastConfigFile = ref('')
const boxLastFirmwareFile = ref('')
const boxLastConfigFile = ref('')

const pluginVersion = ref('')
const pluginStatus = ref(1)

// 新增升级次数相关状态
const upgradeCountInfo = ref({
  userId: '',
  remainingCount: 0,
  upgradeType: 0 // 升级类型标识：0=0个#号，1=1个#号，2=2个#号
})
const showApplyButton = ref(false)
const applyLoading = ref(false)
const upgradeCountLoaded = ref(false) // 升级次数信息是否已加载


let ws = null
let wsPath
let canUartListUpdated = false

onMounted(() => {
  checkBoxTabVisibility()
  connectMotor()
  
  // 添加beforeunload事件监听器，处理标签页关闭情况
  const handleBeforeUnload = () => {
    // 如果当前是电池tab，发送BMS_exit_boot指令
    if (activeName.value === 'battery') {
      // 使用同步方式发送，因为页面即将关闭
      if (ws && ws.readyState === WebSocket.OPEN) {
        const command = { cmd: 'BMS_exit_boot', param: '' };
        ws.send(JSON.stringify(command));
      }
    }
  };
  
  // 添加事件监听器
  window.addEventListener('beforeunload', handleBeforeUnload);
  
  // 存储事件处理函数引用，以便在组件卸载时移除
  window._handleBeforeUnload = handleBeforeUnload;
})

// 监听activeName的变化
watch(activeName, (newValue, oldValue) => {

  
  // 如果从电池tab切换到其他tab，发送BMS_exit_boot指令
  if (oldValue === 'battery' && newValue !== 'battery') {
    wsSend('BMS_exit_boot', '');
  }
});

onUnmounted(() => {
  // 如果当前是电池tab，发送BMS_exit_boot指令
  if (activeName.value === 'battery') {
    wsSend('BMS_exit_boot', '');
  }
  
  // 移除beforeunload事件监听器
  if (window._handleBeforeUnload) {
    window.removeEventListener('beforeunload', window._handleBeforeUnload);
    delete window._handleBeforeUnload;
  }
  
  ws.close()
  ws = null

})



async function connectMotor() {
  motorConnectLoading.value = true
  motorConnected.value = false
  //清空固件列表
  await initWs()
  // 重置升级次数相关状态
  resetUpgradeCountInfo()
  setTimeout(() => {
    wsSend('closePort')
  }, 200)
  setTimeout(() => {
    connectMotorWs()
  }, 500);
}

async function connectDisplay() {
  displayConnectLoading.value = true
  displayConnected.value = false
  //清空固件列表
  resetDisplayUploadFiles()
  await initWs()
  // 重置升级次数相关状态
  resetUpgradeCountInfo()
  setTimeout(() => {
    wsSend('closePort')
  }, 200)
  setTimeout(() => {
    connectDisplayWs()
  }, 500);
}

async function connectBattery() {
  batteryConnectLoading.value = true
  batteryConnected.value = false
  //清空固件列表
  resetBatteryUploadFiles()
  await initWs()
  // 重置升级次数相关状态
  resetUpgradeCountInfo()
  setTimeout(() => {
    wsSend('closePort')
  }, 200)
  setTimeout(() => {
    connectBatteryWs()
  }, 500);
}

async function connectBox() {
  boxConnectLoading.value = true
  boxConnected.value = false
  //清空固件列表
  resetBoxUploadFiles()
  await initWs()
  // 重置升级次数相关状态
  resetUpgradeCountInfo()
  setTimeout(() => {
    wsSend('closePort')
  }, 200)
  setTimeout(() => {
    connectBoxWs()
  }, 500);
}

// 重置升级次数相关状态
function resetUpgradeCountInfo() {
  upgradeCountInfo.value = {
    userId: '',
    remainingCount: 0,
    upgradeType: 0
  }
  showApplyButton.value = false
  upgradeCountLoaded.value = false
  userType.value = ''
}

async function checkBoxTabVisibility() {
  const organizationName = localStorage.getItem('organizationName')
  if (organizationName === 'Prophete-in-moving') {
    const organizationId = localStorage.getItem('organizationId')
    try {
      const res = await api.firmwareList({
        type: 3,
        organization_id: organizationId,
        productType: 3
      })
      if (res?.code === 0 && res?.data && res.data.length > 0) {
        showBoxTab.value = true
      } else {
        showBoxTab.value = false
      }
    } catch (error) {
      showBoxTab.value = false
    }
  } else {
    showBoxTab.value = true
  }
}

function connectDisplayWs() {
  if (ws.readyState == WebSocket.OPEN) {
    resetDisplayInfo()
    wsSend('getDisplayInfo_boot')
  } else {
    console.error(t('ProductUpgrade.connectionFailure'))
    displayConnectLoading.value = false
  }

}

function connectBatteryWs() {
  if (ws.readyState == WebSocket.OPEN) {
    resetBatteryInfo()
    wsSend('getBatteryInfo_boot')
  } else {
    console.error(t('ProductUpgrade.connectionFailure'))
    batteryConnectLoading.value = false
  }

}

function connectBoxWs() {
  if (ws.readyState == WebSocket.OPEN) {
    resetBoxInfo()
    wsSend('getBoxInfo_boot')
  } else {
    console.error(t('ProductUpgrade.connectionFailure'))
    boxConnectLoading.value = false
  }

}

function initWs() {

  if (ws !== null && ws.readyState === WebSocket.OPEN) return
  ws = new WebSocket('ws://127.0.0.1:1234')
  ws.onopen = () => {
    wsSend('getExeVer')
    setTimeout(() => {
      wsSend('getAppDataPath')
    }, 200);
    // 重置标记，确保每次重新连接时都会重新发送updateCanList和updateUartList
    canUartListUpdated = false
  }
  ws.onmessage = async message => {

    let messageData = JSON.parse(message.data)

    // 无论什么命令，只要包含升级次数信息且满足条件，就更新申请按钮状态
    if (messageData.data) {
      try {
        const dataObj = typeof messageData.data === 'string' ? JSON.parse(messageData.data) : messageData.data
        if (dataObj.remainingCount === 0 && dataObj.upgradeType === 1 && dataObj.userId) {
          // 如果dataObj中包含userType信息，就使用它来更新全局的userType变量
          if (dataObj.userType) {
            userType.value = dataObj.userType;
          }
          // 更新本地状态
          upgradeCountInfo.value.userId = dataObj.userId
          upgradeCountInfo.value.remainingCount = dataObj.remainingCount
          upgradeCountInfo.value.upgradeType = dataObj.upgradeType
          showApplyButton.value = true
          // 只有用户类型为normal时，才显示升级次数信息
          upgradeCountLoaded.value = userType.value === 'normal'
        }
      } catch (error) {
        // 解析失败时忽略，不影响其他功能
      }
    }

    if (messageData.cmd === 'getExeVer') {
      if (messageData.code === 200) {
        pluginVersion.value = messageData.data
        api.pluginVersion().then(res => {
          if (compareversions(messageData.data, res.version) === -1) {
            pluginVisiable.value = true
            pluginUrl.value = res.file_url
            pluginStatus.value = 2
            return
          }
          api.hardwareProtocol().then(res => {
            wsSend('updateCanList', { param: res.can })
            wsSend('updateUartList', { param: res.uart })
            // 更新标记，确保后续的getMotorInfo_boot可以正常发送
            canUartListUpdated = true
          })

        })
      }
    }

    if (messageData.cmd === 'getMotorInfo_boot') {
      if (messageData.code === 200) {
        ElMessage.success(t('ProductUpgrade.connectionSuccess'))
        var infoData = JSON.parse(messageData.data)
        var productModel
        let params = { "hardware_version-eq": infoData['hardwareversion'] }
        api.productDetail(params).then(res => {
          if (res.data.length > 0) {
            productModel = res.data[0]
            infoData.code = productModel.code
            if(productModel.motor_type == 0) motorName.value = 'ProductDiagnosis.centerMotor'
            if(productModel.motor_type == 1) {
              motorName.value = 'ProductDiagnosis.wheelMotor'
              motorIcon.value = 'inwheel'
            }
          }else{
            //发送未获取到型号信息
            api.productNotify({'hardwareVersion':infoData['hardwareversion'],'softwareVersion':infoData['softwareversion']})
          }
        }).catch(err => {
          console.error('获取产品详情失败:', err)
        }).finally(() => {
          motorInfo.value = motorInfo.value.map(item => {
            return { ...item, value: infoData[item.key] }
          })
          motorConnected.value = true

          // 优先检查序列号升级文件
          let serialNumber = '';
          const currentInfo = motorInfo.value || [];

          if (currentInfo && Array.isArray(currentInfo)) {
            const snItem = currentInfo.find(item => item.key === 'mcusncode');
            if (snItem) {
              serialNumber = snItem.value;

              // 异步检查序列号升级文件
              (async () => {
                try {
                  // 先检查是否存在序列号升级文件
                  const res = await api.getP8UpgradeFiles(serialNumber);

                  let hasSerialUpgrade = false;

                  if (res.data) {
                    // 检查是否有固件文件URL或配置文件URL
                    const dataItem = Array.isArray(res.data) && res.data.length > 0 ? res.data[0] : res.data;
                    if (dataItem && (dataItem.firmware_file_url || dataItem.params_file_url || dataItem.firmware_file || dataItem.params_file)) {
                      hasSerialUpgrade = true;
                      // 直接处理序列号升级文件，避免重复调用接口
                      processSerialNumberUpgradeFiles(res.data);
                    }
                  }

                  // 如果没有序列号升级文件，再检查自动升级文件
                  if (!hasSerialUpgrade) {
                    getFirmwareList(0, infoData);
                    getFirmwareList(1, infoData);
                  }
                } catch (error) {
                  console.error('   - 检查序列号升级文件失败:', error);
                  // 出错时继续检查自动升级文件
                  getFirmwareList(0, infoData);
                  getFirmwareList(1, infoData);
                }
              })();
            } else {
              getFirmwareList(0, infoData);
              getFirmwareList(1, infoData);
            }
          } else {
            getFirmwareList(0, infoData);
            getFirmwareList(1, infoData);
          }

        })


      }
      if (messageData.code === 0) {
        console.error(t('ProductUpgrade.motorConnectionFailure'))
        //型号匹配不到返回：This hardware version cannot be recognised,[型号].
        let messages = messageData.message.split(",")
        if(messages.length > 0 && messages[0] === 'This hardware version cannot be recognised'){
          //发送未获取到型号信息
          api.productNotify({'hardwareVersion':messages[1],'softwareVersion':messages[2]})
        }
      }
      if (messageData.code === 404) {
        ElMessage.error({ message: t('ProductUpgrade.connectionFailedNoCOMPort'), duration: 5000 })
      }
      motorConnectLoading.value = false
      api.addConnectRecord({
        cmd: messageData.cmd,
        code: messageData.code,
        message: messageData.message ? messageData.message.substring(0, 255) : '', // 限制message字段长度
        data: messageData.data,
        type: 0,
        plugin_version: pluginVersion.value
      }).catch(err => {
        console.error('添加连接记录失败:', err)
      })
    }

    if (messageData.cmd === 'getAppDataPath') {
      if (messageData.code === 200) {
        wsPath = messageData.data
      }
    }

    if (messageData.cmd === 'UpdateDeviceProgress') {
      if (messageData.code === 200) {
        var progressData = JSON.parse(messageData.data)

        if (progressData?.filetype === 1) {
          configPercentage.value = Math.round(progressData?.UpdatedDataCounts / progressData?.UpdateTotalCounts * 100)
        }

        if (progressData?.filetype === 2) {
          percentage.value = Math.round(progressData?.UpdatedDataCounts / progressData?.UpdateTotalCounts * 100)
        }

      }

    }

    if (messageData.cmd === 'getDisplayInfo_boot') {
      if (messageData.code === 200) {
        displayConnected.value = true
        var displayInfoData = JSON.parse(messageData.data)
        api.productDetail({ "hardware_version-eq": displayInfoData['hardwareversion'] }).then(res => {
          if (res.data.length > 0) {
            productModel = res.data[0]
            displayInfoData.code = productModel.code
            displayUploadFiles.value.config.visible = (productModel.has_config === 1)
          }
        }).catch(err => {
          console.error('获取产品详情失败:', err)
        }).finally(() => {
          let displayInfoMap = displayInfo.value
          displayInfo.value = displayInfoMap.map(item => {
            return { ...item, value: displayInfoData[item.key] || '' }
          })
          getFirmwareList(2, displayInfoData)

        })

      }
      if (messageData.code === 0) {
        console.error(t('ProductUpgrade.meterConnectionFailure'))
      }
      if (messageData.code === 404) {
        ElMessage.error({ message: t('ProductUpgrade.connectionFailedNoCOMPort'), duration: 5000 })
      }
      displayConnectLoading.value = false
      api.addConnectRecord({
        cmd: messageData.cmd,
        code: messageData.code,
        message: messageData.message ? messageData.message.substring(0, 255) : '', // 限制message字段长度
        data: messageData.data,
        type: 1,
        plugin_version: pluginVersion.value
      }).catch(err => {
        console.error('添加连接记录失败:', err)
      })
    }

    if (messageData.cmd === 'getBatteryInfo_boot') {
      if (messageData.code === 200) {
        batteryConnected.value = true
        var batteryInfoData = JSON.parse(messageData.data)
        api.productDetail({ "hardware_version-eq": batteryInfoData['hardwareversion'] }).then(res => {
          if (res.data.length > 0) {
            productModel = res.data[0]
            batteryInfoData.code = productModel.code
          }
        }).catch(err => {
          console.error('获取产品详情失败:', err)
        }).finally(() => {
          let batteryInfoMap = batteryInfo.value
          batteryInfo.value = batteryInfoMap.map(item => {
            return { ...item, value: batteryInfoData[item.key] || '' }
          })
        })
      }
      if (messageData.code === 0) {
        console.error(t('ProductUpgrade.batteryConnectionFailure'))
      }
      if (messageData.code === 404) {
        ElMessage.error({ message: t('ProductUpgrade.connectionFailedNoCOMPort'), duration: 5000 })
      }
      batteryConnectLoading.value = false
      api.addConnectRecord({
        cmd: messageData.cmd,
        code: messageData.code,
        message: messageData.message ? messageData.message.substring(0, 255) : '', // 限制message字段长度
        data: messageData.data,
        type: 2,
        plugin_version: pluginVersion.value
      }).catch(err => {
        console.error('添加连接记录失败:', err)
      })
    }
    if (messageData.cmd === 'getBoxInfo_boot') {
      if (messageData.code === 200) {
        boxConnected.value = true
        var boxInfoData = JSON.parse(messageData.data)
        api.productDetail({ "hardware_version-eq": boxInfoData['hardwareversion'] }).then(res => {
          if (res.data.length > 0) {
            productModel = res.data[0]
            boxInfoData.code = productModel.code
          }
        }).catch(err => {
          console.error('获取产品详情失败:', err)
        }).finally(() => {
          let boxInfoMap = boxInfo.value
          boxInfo.value = boxInfoMap.map(item => {
            return { ...item, value: boxInfoData[item.key] || '' }
          })
          getFirmwareList(3, boxInfoData)
        })
      }
      if (messageData.code === 0) {
        console.error(t('ProductUpgrade.boxConnectionFailure'))
      }
      if (messageData.code === 404) {
        ElMessage.error({ message: t('ProductUpgrade.connectionFailedNoCOMPort'), duration: 5000 })
      }
      boxConnectLoading.value = false
      api.addConnectRecord({
        cmd: messageData.cmd,
        code: messageData.code,
        message: messageData.message ? messageData.message.substring(0, 255) : '', // 限制message字段长度
        data: messageData.data,
        type: 3,
        plugin_version: pluginVersion.value
      }).catch(err => {
        console.error('添加连接记录失败:', err)
      })
    }

    if (messageData.cmd === 'DeviceLose') {
      ElMessage.error(t('ProductUpgrade.connectionLost'))
      motorConnected.value = false
      displayConnected.value = false
      batteryConnected.value = false
      boxConnected.value = false
      motorProgress.value = false
      displayProgress.value = false
      batteryProgress.value = false
      boxProgress.value = false
    }
    if (messageData.cmd === 'UpdateDevice') {
      let updateDeviceData = {
        status: -1,
        message: messageData?.message,
        user_id: localStorage.getItem('userId'),
        organization_id: localStorage.getItem('organizationId'),
        plugin_version: pluginVersion.value,
      }
      if (motorProgress.value) {
        updateDeviceData.type = 0
        updateDeviceData.before_version = motorInfo.value[2].value
        updateDeviceData.firmware_id = motorFirmwareId | motorConfigId
        updateDeviceData.config_id = motorConfigId
        updateDeviceData.firmware_file_name = uploadFiles.value.firmware.fileName
        updateDeviceData.firmware_key = uploadFiles.value.firmware.key
        updateDeviceData.config_file_name = uploadFiles.value.config.fileName
        updateDeviceData.config_key = uploadFiles.value.config.key
        updateDeviceData.model_code = motorInfo.value[0].value
      }
      if (displayProgress.value) {
        updateDeviceData.type = 1
        updateDeviceData.before_version = displayInfo.value[2].value
        updateDeviceData.firmware_id = displayFirmwareId
        updateDeviceData.config_id = displayconfigId
        updateDeviceData.firmware_file_name = displayUploadFiles.value.firmware.fileName
        updateDeviceData.firmware_key = displayUploadFiles.value.firmware.key
        updateDeviceData.config_file_name = displayUploadFiles.value.config.fileName
        updateDeviceData.config_key = displayUploadFiles.value.config.key
        updateDeviceData.model_code = displayInfo.value[0].value

      }
      if (batteryProgress.value) {
        updateDeviceData.type = 2
        updateDeviceData.before_version = batteryInfo.value[0].value
        updateDeviceData.firmware_id = batteryFirmwareId
        updateDeviceData.firmware_file_name = batteryUploadFiles.value.firmware.fileName
        updateDeviceData.firmware_key = batteryUploadFiles.value.firmware.key
        updateDeviceData.model_code = '' // 电池模块不再显示型号

      }
      if (boxProgress.value) {
        updateDeviceData.type = 3
        updateDeviceData.before_version = boxInfo.value[0].value
        updateDeviceData.firmware_id = boxFirmwareId
        updateDeviceData.firmware_file_name = boxUploadFiles.value.firmware.fileName
        updateDeviceData.firmware_key = boxUploadFiles.value.firmware.key
        updateDeviceData.model_code = '' // 盒子模块不再显示型号

      }

      // 实际环境：直接使用WebSocket返回的数据处理
      if(messageData.code === 200) {
        ElMessage.success(t('ProductUpgrade.upgradeSuccess'))
        updateDeviceData.status = 1
        // 设置升级完成状态为true，触发显示完成按钮
        if (motorProgress.value) {
          motorUpgradeCompleted.value = true
        }
        if (displayProgress.value) {
          displayUpgradeCompleted.value = true
        }
        if (batteryProgress.value) {
          batteryUpgradeCompleted.value = true
        }
        if (boxProgress.value) {
          boxUpgradeCompleted.value = true
        }
        if(messageData.data != undefined){
          updateDeviceData.after_version = JSON.parse(messageData.data).UpateAfterFirmware
          updateDeviceData.spend_second = JSON.parse(messageData.data).TotalTimes
          
          // 更新升级后的版本信息
          if (motorProgress.value) {
            motorAfterVersion.value = JSON.parse(messageData.data).UpateAfterFirmware
          } else if (displayProgress.value) {
            displayAfterVersion.value = JSON.parse(messageData.data).UpateAfterFirmware
          } else if (batteryProgress.value) {
            batteryAfterVersion.value = JSON.parse(messageData.data).UpateAfterFirmware
          } else if (boxProgress.value) {
            boxAfterVersion.value = JSON.parse(messageData.data).UpateAfterFirmware
          }

          // 解析data中的userId、remainingCount、upgradeType和userType
          const dataObj = JSON.parse(messageData.data);


          // 修改条件判断为upgradeType === 1，与注释一致
          if (dataObj.upgradeType === 1 && dataObj.userType === 'normal' && dataObj.userId !== undefined && dataObj.remainingCount !== undefined) {
            // 当upgradeType为1且userType为normal时，调用修改剩余次数的接口
            updateUserUpgradeInfo(dataObj.userId, dataObj.remainingCount, dataObj.upgradeType);
          }
        }
        // 升级成功后重置用户类型
        userType.value = '';
      } else {
        // 处理所有错误码的统一逻辑
        updateDeviceData.status = 0
        
        // 特殊错误消息处理
        let errorMessage = t('ProductUpgrade.upgradeFailure')
        if (messageData.code === 400) {
          // code=400的情况，提示上传文件失败，请重新上传
          errorMessage = t('ProductUpgrade.uploadFileFailed')
        } else if (messageData.code === 7 && messageData.message) {
          // code=7的特殊情况，如果有自定义消息则使用自定义消息
          errorMessage = messageData.message
        } else if (messageData.code === 13) {
          // code=13的情况，提示升级过程中写数据没写成功
          errorMessage = t('ProductUpgrade.writeDataFailed')
        } else if (messageData.message) {
          // 其他情况，如果有自定义消息则使用自定义消息
          errorMessage = messageData.message
        } else if (messageData.code === 7) {
          // code=7的默认特殊错误消息
          errorMessage = t('ProductUpgrade.overloadFault')
        }
        
        // 显示错误消息
        ElMessage.error({ message: errorMessage, position: 'center' })
        
        // 重置进度状态
        displayProgress.value = false
        motorProgress.value = false
        batteryProgress.value = false
        boxProgress.value = false
        
        // 所有错误情况下都重置用户类型
        userType.value = '';
        
        // code=11的特殊处理已移至全局WebSocket消息处理逻辑中
      }

      // 处理WebSocket返回的升级信息，更新后端
      if (messageData.userId && messageData.remainingCount !== undefined && messageData.upgradeType !== undefined) {
        // 当type为normal且upgradeType为0或2时，只更新本地状态，不调用后端接口
        if (messageData.type === 'normal' && (messageData.upgradeType === 0 || messageData.upgradeType === 2)) {
          // 直接更新本地状态，不调用后端接口
          upgradeCountInfo.value.userId = messageData.userId;
          upgradeCountInfo.value.remainingCount = messageData.remainingCount;
          upgradeCountInfo.value.upgradeType = messageData.upgradeType;
          showApplyButton.value = messageData.remainingCount === 0;
          upgradeCountLoaded.value = false; // upgradeType不为1时，不显示升级次数信息
        }
        // 当upgradeType为1、次数为0且errcode为10时，显示弹窗提示用户升级次数已用完，并直接更新本地状态
        else if (messageData.upgradeType === 1 && messageData.remainingCount === 0 && messageData.errcode === 10) {
          ElMessage.error({ message: '您的升级次数已经用完，请重新申请', position: 'center', duration: 5000 });

          // 直接更新本地状态，不调用后端接口
          upgradeCountInfo.value.userId = messageData.userId;
          upgradeCountInfo.value.remainingCount = messageData.remainingCount;
          upgradeCountInfo.value.upgradeType = messageData.upgradeType;
          // 只有用户类型为normal时，才显示申请按钮和升级次数信息
          if (messageData.type === 'normal') {
            showApplyButton.value = true; // 次数为0时显示申请按钮
            upgradeCountLoaded.value = true; // 标记为已加载，显示升级次数信息
          } else {
            showApplyButton.value = false;
            upgradeCountLoaded.value = false;
          }
        } else {
          // 其他情况，正常调用后端接口
          await updateUserUpgradeInfo(messageData.userId, messageData.remainingCount, messageData.upgradeType)
        }
      }

      // 升级成功时不自动关闭对话框，等待用户手动点击完成按钮
      // 不再自动重新连接设备，设备重新连接将在用户点击完成按钮后通过resetUpgradeStatus函数处理
      if (motorProgress.value) {
        // 保留文件名称以显示已上传的文件信息
        // 不设置 motorProgress.value = false，让对话框保持显示
        // 设置百分比为100%，显示完成状态
        percentage.value = 100
        if (configPercentage.value > 0) {
          configPercentage.value = 100
        }
      }
      if (displayProgress.value) {
        // 保留文件名称以显示已上传的文件信息
        // 不设置 displayProgress.value = false，让对话框保持显示
        // 设置百分比为100%，显示完成状态
        percentage.value = 100
        if (configPercentage.value > 0) {
          configPercentage.value = 100
        }
      }
      if (batteryProgress.value) {
        // 保留文件名称以显示已上传的文件信息
        // 不设置 batteryProgress.value = false，让对话框保持显示
        // 设置百分比为100%，显示完成状态
        percentage.value = 100
        if (configPercentage.value > 0) {
          configPercentage.value = 100
        }
      }
      api.addUpgradeRecords(updateDeviceData)
      // 不再重置百分比值，保持为100%显示
    }
    if (messageData.cmd === 'UpdateDevice_Cancel') {
      if (messageData?.code !== 200) {
        ElMessage.error(messageData?.message || t('ProductUpgrade.cancelUpgradeFailure'))
      }
      cancelLoading.value = false
      // 重置进度条
      percentage.value = 0
      configPercentage.value = 0
      // 关闭进度对话框
      motorProgress.value = false
      displayProgress.value = false
      batteryProgress.value = false
      boxProgress.value = false
    }
    
    if (messageData.cmd === 'downloadfile') {
      if (messageData.code === 0) {
        ElMessage.error(t('ProductUpgrade.uploadFileFailed'))
        downloadFileFailed.value = true
      } else if (messageData.code === 200) {
        downloadFileFailed.value = false
      }
    }
  }
  ws.onerror = () => {
    motorConnectLoading.value = false
  }
  ws.onclose = () => {
    motorConnected.value = false
    displayConnected.value = false
    batteryConnected.value = false
  }
}

function connectMotorWs() {

  if(ws === null) return
  if (ws.readyState === WebSocket.OPEN) {
    resetMotorInfo()
    // 确保在发送getMotorInfo_boot之前，updateCanList和updateUartList已经发送完成
    if (canUartListUpdated) {
      wsSend('getMotorInfo_boot')
    } else {
      // 等待一小段时间，确保getExeVer的响应已经处理完成
      setTimeout(() => {
        if (canUartListUpdated) {
          wsSend('getMotorInfo_boot')
        } else {
          // 先发送updateCanList和updateUartList
          api.hardwareProtocol().then(res => {
            wsSend('updateCanList', { param: res.can })
            wsSend('updateUartList', { param: res.uart })
            // 标记为已更新
            canUartListUpdated = true
            // 然后发送getMotorInfo_boot
            wsSend('getMotorInfo_boot')
          })
        }
      }, 300)
    }
  } else {
    console.error(t('ProductUpgrade.connectionFailure'))
    motorConnectLoading.value = false
    api.pluginVersion().then(res => {
      pluginVisiable.value = true;
      pluginUrl.value = res.file_url;

    })
  }

}
function resetMotorInfo() {
  motorInfo.value = motorInfo.value.map((item) => {
    item.value = '';
    return item
  })
  resetUploadFiles()
  motorLastFirmwareFile.value = ''
  motorLastConfigFile.value = ''
}

function resetDisplayInfo() {
  displayInfo.value = displayInfo.value.map((item) => {
    item.value = ''
    return item
  })
  resetDisplayUploadFiles()
  displayLastFirmwareFile.value = ''
  displayLastConfigFile.value = ''
}

function resetBatteryInfo() {
  batteryInfo.value = batteryInfo.value.map((item) => {
    item.value = ''
    return item
  })
  resetBatteryUploadFiles()
  batteryLastFirmwareFile.value = ''
  batteryLastConfigFile.value = ''
}

function resetBoxInfo() {
  boxInfo.value = boxInfo.value.map((item) => {
    item.value = ''
    return item
  })
  resetBoxUploadFiles()
  boxLastFirmwareFile.value = ''
  boxLastConfigFile.value = ''
}
async function uploadSuccess(res, type, key) {
  if (res.code == -100) {
    localStorage.removeItem('token');
    router.push('/LoginPage');
    return
  }
  if (res.code !== 0) return
  
  // 重置下载失败状态，确保每次上传都能正常尝试下载
  downloadFileFailed.value = false;
  
  // 本地上传文件时重置用户类型，确保重新判断
  userType.value = '';

  if (type === 'motor') {
    uploadFiles.value[key].fileUrl = wsPath + '\\' + res.fileName
    uploadFiles.value[key].fileName = res.fileName
    uploadFiles.value[key].key = res.key
  }
  if (type === 'display') {
    displayUploadFiles.value[key].fileUrl = wsPath + '\\' + res.fileName
    displayUploadFiles.value[key].fileName = res.fileName
    displayUploadFiles.value[key].key = res.key
  }
  if (type === 'battery') {
    batteryUploadFiles.value[key].fileUrl = wsPath + '\\' + res.fileName
    batteryUploadFiles.value[key].fileName = res.fileName
    batteryUploadFiles.value[key].key = res.key
    
    // 添加上传的文件到下拉框选项中
    const uploadedFile = {
      fileName: res.fileName,
      fileUrl: wsPath + '\\' + res.fileName,
      value: wsPath + '\\' + res.fileName, // 添加value属性，与fileUrl相同
      key: res.key,
      id: Date.now() // 使用时间戳作为临时ID
    }
    
    // 确保options数组存在
    if (!batteryUploadFiles.value[key].options) {
      batteryUploadFiles.value[key].options = []
    }
    
    // 将上传的文件添加到选项中，并设置为当前选择的文件
    batteryUploadFiles.value[key].options = [uploadedFile]
    batteryUploadFiles.value[key].fileName = res.fileName // 确保当前选择的文件是上传的文件
  }
  if (type === 'box') {
    boxUploadFiles.value[key].fileUrl = wsPath + '\\' + res.fileName
    boxUploadFiles.value[key].fileName = res.fileName
    boxUploadFiles.value[key].key = res.key
    
    // 添加上传的文件到下拉框选项中
    const uploadedFile = {
      fileName: res.fileName,
      fileUrl: wsPath + '\\' + res.fileName,
      value: wsPath + '\\' + res.fileName, // 添加value属性，与fileUrl相同
      key: res.key,
      id: Date.now() // 使用时间戳作为临时ID
    }
    
    // 确保options数组存在
    if (!boxUploadFiles.value[key].options) {
      boxUploadFiles.value[key].options = []
    }
    
    // 将上传的文件添加到选项中，并设置为当前选择的文件
    boxUploadFiles.value[key].options = [uploadedFile]
    boxUploadFiles.value[key].fileName = res.fileName // 确保当前选择的文件是上传的文件
  }
  if (!downloadFileFailed.value) {
    wsSend('downloadfile', {
      p1: res.fileName,
      p2: res.url,
      p3: res.fileSize
    })
  }
}

async function upgrade(type) {
  // 先获取最新的升级次数信息
  await getUserUpgradeCountInfo()

  // 升级开始时重置进度条
  percentage.value = 0
  configPercentage.value = 0
  
  // 升级开始时重置升级完成状态，确保第二次升级能正常显示完成按钮
  if (type === 'motor') {
    motorUpgradeCompleted.value = false
  } else if (type === 'display') {
    displayUpgradeCompleted.value = false
  } else if (type === 'battery') {
    batteryUpgradeCompleted.value = false
  } else if (type === 'box') {
    boxUpgradeCompleted.value = false
  }

  if (type === 'motor') {
    if (ws.readyState == WebSocket.OPEN && motorConnected) {
      //进入boot
      motorFirmwareId = getFirmwareId(uploadFiles.value.firmware)
      motorConfigId = getFirmwareId(uploadFiles.value.config)
      motorProgress.value = true
      uploadFiles.value.firmware.fileUrl = getFirmwareFileUrl(uploadFiles.value.firmware)
      uploadFiles.value.firmware.key = getFirmwareKey(uploadFiles.value.firmware)
      uploadFiles.value.config.fileUrl = getFirmwareFileUrl(uploadFiles.value.config)
      uploadFiles.value.config.key = getFirmwareKey(uploadFiles.value.config)


      // 获取当前用户ID，判断是否为特殊账号
      const userId = localStorage.getItem('userId') || '';

      // 获取当前选择的固件版本号（softwareversion）和参数版本号（parameterversion）
      // 从motorInfo中查找对应的版本信息
      const softwareVersionItem = motorInfo.value.find(item => item.key === 'softwareversion');
      const selectedFirmwareVersion = softwareVersionItem ? softwareVersionItem.value : '';
      const parameterVersionItem = motorInfo.value.find(item => item.key === 'parameterversion');
      const selectedParameterVersion = parameterVersionItem ? parameterVersionItem.value : '';

      // 获取当前时间戳
      const currentTime = new Date().getTime();

      // 确定用户类型，优先使用全局userType（可能在P8检查时已经设置）
        let finalUserType = userType.value || 'normal';
        
        // 如果用户类型已经是P8，则不再进行后续的特殊账号和定制账号检查
        if (finalUserType !== 'P8') {
          try {
            // 1. 检查是否为时间限制的特殊账号 - 使用 special 类型
          // 直接调用API并传入用户ID和启用状态参数，获取当前用户的特殊账号信息
          const specialAccountRes = await getSpecialAccounts(1, 1, {
            'user_id-eq': userId,
            'enable-eq': 1
          });

          if (specialAccountRes && specialAccountRes.data && specialAccountRes.data.length > 0) {
            const specialAccount = specialAccountRes.data[0];

            // 获取时间范围
            const startTime = specialAccount.begin_at ?
                new Date(specialAccount.begin_at).getTime() : 0;
            const endTime = specialAccount.end_at ?
                new Date(specialAccount.end_at).getTime() : 0;



            // 在前端判断当前时间是否在有效范围内
            if (currentTime >= startTime && currentTime <= endTime) {
              finalUserType = 'special';
            }
          }

          // 2. 如果不是时间限制的特殊账号，则检查是否为指定固件或参数的特殊账号 - 使用 custom 类型
          // 先查询固件版本，如果查不到再查询参数版本
          if (finalUserType !== 'special') {
            let isCustomAccount = false;

            // 首先尝试通过固件版本号查询
            if (selectedFirmwareVersion) {
              const firmwareAccountRes = await getUpgradeRulesList(1, 1, {
                'user_id-eq': userId,
                'version-eq': selectedFirmwareVersion,
                'enable-eq': 1
              });

              if (firmwareAccountRes && firmwareAccountRes.data && firmwareAccountRes.data.length > 0) {
                isCustomAccount = true;
              }
            }

            // 如果通过固件版本未查询到，且存在参数版本，则尝试通过参数版本号查询
            if (!isCustomAccount && selectedParameterVersion) {
              const parameterAccountRes = await getUpgradeRulesList(1, 1, {
                'user_id-eq': userId,
                'version-eq': selectedParameterVersion,
                'enable-eq': 1
              });

              if (parameterAccountRes && parameterAccountRes.data && parameterAccountRes.data.length > 0) {
                isCustomAccount = true;
              }
            }

            if (isCustomAccount) {
              finalUserType = 'custom';
            }
          }
        } catch (error) {
          console.error('查询特殊账号信息失败:', error);
          // 出错时默认使用普通用户类型
        }
      }


      
      setTimeout(() => {
        if (!downloadFileFailed.value) {
          wsSend('UpdateDevice', {
            devicetype: 'motor',
            p1: uploadFiles.value.firmware.fileUrl,
            p2: uploadFiles.value.config.fileUrl,
            userId: upgradeCountInfo.value.userId,
            remainingCount: upgradeCountInfo.value.remainingCount,
            userType: finalUserType
          })
        }
      }, 1000);

    }
  }
  if (type === 'display') {
    if (ws.readyState == WebSocket.OPEN && displayConnected) {
      displayProgress.value = true
      displayFirmwareId = getFirmwareId(displayUploadFiles.value.firmware)
      displayconfigId = getFirmwareId(displayUploadFiles.value.config)

      displayUploadFiles.value.firmware.fileUrl = getFirmwareFileUrl(displayUploadFiles.value.firmware)
      displayUploadFiles.value.firmware.key = getFirmwareKey(displayUploadFiles.value.firmware)
      displayUploadFiles.value.config.fileUrl = getFirmwareFileUrl(displayUploadFiles.value.config)
      displayUploadFiles.value.config.key = getFirmwareKey(displayUploadFiles.value.config)

      // 获取当前用户ID，判断是否为特殊账号
      const userId = localStorage.getItem('userId') || '';

      // 获取当前仪表的固件版本号（softwareversion）
      const displaySoftwareVersionItem = displayInfo.value.find(item => item.key === 'softwareversion');
      const displaySelectedFirmwareVersion = displaySoftwareVersionItem ? displaySoftwareVersionItem.value : '';

      // 获取当前时间戳
      const currentTime = new Date().getTime();

      // 确定用户类型，优先使用全局userType（可能在P8检查时已经设置）
      let finalUserType = userType.value || 'normal';

      // 如果用户类型已经是P8，则不再进行后续的特殊账号和定制账号检查
      if (finalUserType !== 'P8') {
        try {
          // 1. 检查是否为时间限制的特殊账号 - 使用 special 类型
          // 直接调用API并传入用户ID和启用状态参数，获取当前用户的特殊账号信息
          const specialAccountRes = await getSpecialAccounts(1, 1, {
            'user_id-eq': userId,
            'enable-eq': 1
          });

          if (specialAccountRes && specialAccountRes.data && specialAccountRes.data.length > 0) {
            const specialAccount = specialAccountRes.data[0];

            // 获取时间范围
            const startTime = specialAccount.begin_at ?
                new Date(specialAccount.begin_at).getTime() : 0;
            const endTime = specialAccount.end_at ?
                new Date(specialAccount.end_at).getTime() : 0;

            // 在前端判断当前时间是否在有效范围内
            if (currentTime >= startTime && currentTime <= endTime) {
              finalUserType = 'special';
            }
          }

          // 2. 如果不是时间限制的特殊账号，则检查是否为指定固件的特殊账号 - 使用 custom 类型
          if (finalUserType !== 'special') {
            let isCustomAccount = false;

            // 尝试通过固件版本号查询
            if (displaySelectedFirmwareVersion) {
              const firmwareAccountRes = await getUpgradeRulesList(1, 1, {
                'user_id-eq': userId,
                'version-eq': displaySelectedFirmwareVersion,
                'enable-eq': 1
              });

              if (firmwareAccountRes && firmwareAccountRes.data && firmwareAccountRes.data.length > 0) {
                isCustomAccount = true;
              }
            }

            if (isCustomAccount) {
              finalUserType = 'custom';
            }
          }
        } catch (error) {
          console.error('查询特殊账号信息失败:', error);
          // 出错时默认使用普通用户类型
        }
      }


      setTimeout(() => {
        if (!downloadFileFailed.value) {
          wsSend('UpdateDevice', {
            devicetype: 'dsp',
            p1: displayUploadFiles.value.firmware.fileUrl,
            p2: displayUploadFiles.value.config.fileUrl,
            userId: upgradeCountInfo.value.userId,
            remainingCount: upgradeCountInfo.value.remainingCount,
            userType: finalUserType
          })
        }
      }, 1000);

    }
  }
  if (type === 'battery') {
    if (ws.readyState == WebSocket.OPEN && batteryConnected) {
      batteryProgress.value = true
      batteryFirmwareId = getFirmwareId(batteryUploadFiles.value.firmware)
      
      // 调试信息


      
      batteryUploadFiles.value.firmware.fileUrl = getFirmwareFileUrl(batteryUploadFiles.value.firmware)
      batteryUploadFiles.value.firmware.key = getFirmwareKey(batteryUploadFiles.value.firmware)
      
      // 调试信息


      // 获取当前用户ID
      const userId = localStorage.getItem('userId') || '';

      // 获取当前电池的固件版本号
      const batterySoftwareVersionItem = batteryInfo.value.find(item => item.key === 'softwareversion');
      const batterySelectedFirmwareVersion = batterySoftwareVersionItem ? batterySoftwareVersionItem.value : '';

      // 获取当前时间戳
      const currentTime = new Date().getTime();

      // 确定用户类型
      let finalUserType = userType.value || 'normal';

      // 如果用户类型已经是P8，则不再进行后续的特殊账号和定制账号检查
      if (finalUserType !== 'P8') {
        try {
          // 1. 检查是否为时间限制的特殊账号
          const specialAccountRes = await getSpecialAccounts(1, 1, {
            'user_id-eq': userId,
            'enable-eq': 1
          });

          if (specialAccountRes && specialAccountRes.data && specialAccountRes.data.length > 0) {
            const specialAccount = specialAccountRes.data[0];

            const startTime = specialAccount.begin_at ?
                new Date(specialAccount.begin_at).getTime() : 0;
            const endTime = specialAccount.end_at ?
                new Date(specialAccount.end_at).getTime() : 0;

            if (currentTime >= startTime && currentTime <= endTime) {
              finalUserType = 'special';
            }
          }

          // 2. 如果不是时间限制的特殊账号，则检查是否为指定固件的特殊账号
          if (finalUserType !== 'special') {
            let isCustomAccount = false;

            if (batterySelectedFirmwareVersion) {
              const firmwareAccountRes = await getUpgradeRulesList(1, 1, {
                'user_id-eq': userId,
                'version-eq': batterySelectedFirmwareVersion,
                'enable-eq': 1
              });

              if (firmwareAccountRes && firmwareAccountRes.data && firmwareAccountRes.data.length > 0) {
                isCustomAccount = true;
              }
            }

            if (isCustomAccount) {
              finalUserType = 'custom';
            }
          }
        } catch (error) {
          console.error('查询特殊账号信息失败:', error);
        }
      }

      setTimeout(() => {
        if (!downloadFileFailed.value) {
          wsSend('UpdateDevice', {
            devicetype: 'bms',
            p1: batteryUploadFiles.value.firmware.fileUrl,
            p2: '', // 电池没有参数文件
            userId: upgradeCountInfo.value.userId,
            remainingCount: upgradeCountInfo.value.remainingCount,
            userType: finalUserType
          })
        }
      }, 1000);

    }
  }
  if (type === 'box') {
    if (ws.readyState == WebSocket.OPEN && boxConnected) {
      boxProgress.value = true
      boxFirmwareId = getFirmwareId(boxUploadFiles.value.firmware)
      
      boxUploadFiles.value.firmware.fileUrl = getFirmwareFileUrl(boxUploadFiles.value.firmware)
      boxUploadFiles.value.firmware.key = getFirmwareKey(boxUploadFiles.value.firmware)
      
      // 获取当前用户ID
      const userId = localStorage.getItem('userId') || '';

      // 获取当前盒子的固件版本号
      const boxSoftwareVersionItem = boxInfo.value.find(item => item.key === 'softwareversion');
      const boxSelectedFirmwareVersion = boxSoftwareVersionItem ? boxSoftwareVersionItem.value : '';

      // 获取当前时间戳
      const currentTime = new Date().getTime();

      // 确定用户类型
      let finalUserType = userType.value || 'normal';

      // 如果用户类型已经是P8，则不再进行后续的特殊账号和定制账号检查
      if (finalUserType !== 'P8') {
        try {
          // 1. 检查是否为时间限制的特殊账号
          const specialAccountRes = await getSpecialAccounts(1, 1, {
            'user_id-eq': userId,
            'enable-eq': 1
          });

          if (specialAccountRes && specialAccountRes.data && specialAccountRes.data.length > 0) {
            const specialAccount = specialAccountRes.data[0];

            const startTime = specialAccount.begin_at ?
                new Date(specialAccount.begin_at).getTime() : 0;
            const endTime = specialAccount.end_at ?
                new Date(specialAccount.end_at).getTime() : 0;

            if (currentTime >= startTime && currentTime <= endTime) {
              finalUserType = 'special';
            }
          }

          // 2. 如果不是时间限制的特殊账号，则检查是否为指定固件的特殊账号
          if (finalUserType !== 'special') {
            let isCustomAccount = false;

            if (boxSelectedFirmwareVersion) {
              const firmwareAccountRes = await getUpgradeRulesList(1, 1, {
                'user_id-eq': userId,
                'version-eq': boxSelectedFirmwareVersion,
                'enable-eq': 1
              });

              if (firmwareAccountRes && firmwareAccountRes.data && firmwareAccountRes.data.length > 0) {
                isCustomAccount = true;
              }
            }

            if (isCustomAccount) {
              finalUserType = 'custom';
            }
          }
        } catch (error) {
          console.error('查询特殊账号信息失败:', error);
        }
      }

      setTimeout(() => {
        if (!downloadFileFailed.value) {
          wsSend('UpdateDevice', {
            devicetype: 'box',
            p1: boxUploadFiles.value.firmware.fileUrl,
            p2: '', // 盒子没有参数文件
            userId: upgradeCountInfo.value.userId,
            remainingCount: upgradeCountInfo.value.remainingCount,
            userType: finalUserType
          })
        }
      }, 1000);

    }
  }
}

function getFirmwareId(config) {
  var fileName = config.fileName
  var options = config.options
  var item = options.filter(option => { return option.fileName === fileName })
  if (item.length === 0) return ''
  return item[0].id || '' // 确保返回字符串
}
function getFirmwareFileUrl(config) {
  var fileName = config.fileName
  if (fileName === undefined) return ''
  var options = config.options
  var item = options.filter(option => { return option.fileName === fileName })
  if (item.length === 0) return config.fileUrl
  return item[0].value
}
function getFirmwareKey(config) {
  var fileName = config.fileName
  var options = config.options
  var item = options.filter(option => { return option.fileName === fileName })
  if (item.length === 0) return config.key
  return item[0].key
}

function wsSend(cmd, param = '') {

  if (!ws) {

    return
  }

  if (ws.readyState !== WebSocket.OPEN) {

    return
  }

  // 确保remainingCount是整数类型
  if (param && param.remainingCount !== undefined) {
    param.remainingCount = parseInt(param.remainingCount) || 0;
  }

  let message = { cmd: cmd, param: param }
  if (param) {
    message = {
      cmd: cmd,
      ...param
    }
  }


  ws.send(JSON.stringify(message));
}

// tab切换前的处理
function beforeTabLeave(oldActiveName, newActiveName) {

  
  // 如果当前是电池tab且要切换到其他tab，发送BMS_exit_boot指令
  if (oldActiveName === 'battery' && newActiveName !== 'battery') {
    wsSend('BMS_exit_boot', '');
  }
  
  // 返回true允许切换
  return true;
}

// 切换tab
function tabChange (tab) {

  
  // 切换tab时重置用户类型
  userType.value = '';
  if (tab === 'motor') {
    clearSelectFile('motor')
  } else if (tab === 'display') {
    clearSelectFile('display')
  } else if (tab === 'battery') {
    clearSelectFile('battery')
  } else if (tab === 'box') {
    clearSelectFile('box')
  }
}

// P8组织用户的特定升级检查方法
async function checkUpgradeForP8(serialNumber, code) {
  try {

    // 先判断是否为电机设备，P8检查只针对电机
    if (code !== 'motor') {
      return false;
    }

    if (!serialNumber) {
      ElMessage.warning(t('ProductUpgrade.noSerialNumber'));
      return false;
    }

    // 调用API查找P8组织用户对应的参数文件或固件文件
    const res = await api.getP8UpgradeFiles(serialNumber);

    if (res.data) {

      // 处理返回数据 - 从数组中获取第一个元素
      const dataItem = Array.isArray(res.data) && res.data.length > 0 ? res.data[0] : res.data;

      // 检查是否有固件文件URL或配置文件URL
      const hasValidFiles = dataItem && (dataItem.firmware_file || dataItem.firmware_file_url || dataItem.params_file || dataItem.params_file_url);

      if (hasValidFiles) {
        // 更新电机文件信息
        if (dataItem && dataItem.firmware_file) {
          motorLastFirmwareFile.value = dataItem.firmware_file_name;
          // 同时更新uploadFiles中的fileUrl，确保P8用户升级时能正确传递URL
          uploadFiles.value.firmware.fileUrl = dataItem.firmware_file_url || dataItem.firmware_file;
          uploadFiles.value.firmware.fileName = dataItem.firmware_file_name || '';
        }
        if (dataItem && dataItem.params_file) {
          // 获取当前设备的参数版本
          const currentParameterVersion = getInfoValue('parameterversion') || '';
          // 获取服务器返回的参数版本
          const serverParameterVersion = dataItem.config_version || '';
          

          
          // 只有当服务器版本大于当前设备版本时，才更新电机配置文件信息
          if (currentParameterVersion && serverParameterVersion) {
            const compareResult = compareversions(serverParameterVersion, currentParameterVersion);
            
            if (compareResult > 0) {
              motorLastConfigFile.value = dataItem.params_file_name;
              // 同时更新uploadFiles中的fileUrl，确保P8用户升级时能正确传递URL
              uploadFiles.value.config.fileUrl = dataItem.params_file_url || dataItem.params_file;
              uploadFiles.value.config.fileName = dataItem.params_file_name || '';
            }
          }
        }

        // 标记用户类型为P8
        userType.value = 'P8';

        // 设置有可用的序列号升级文件
        hasSerialUpgrade.value = true;
        return true;
      } else {
        // 没有有效文件，触发自动升级
        // ElMessage.info(t('ProductUpgrade.noSerialUpgradeFileAutoUpgrade'));
        // 设置没有可用的序列号升级文件
        hasSerialUpgrade.value = false;
        // 执行自动升级逻辑，等待完成后返回
        await Promise.all([
          getFirmwareList(0, motorInfo.value),
          getFirmwareList(1, motorInfo.value)
        ]);
        return false;
      }
    } else {
      // 设置没有可用的序列号升级文件
      hasSerialUpgrade.value = false;
      // 执行自动升级逻辑，等待完成后返回
      await Promise.all([
        getFirmwareList(0, motorInfo.value),
        getFirmwareList(1, motorInfo.value)
      ]);
      return false;
    }
  } catch (error) {
    console.error('P8 upgrade check failed:', error);
    // 出错时也执行自动升级逻辑，等待完成后返回
    hasSerialUpgrade.value = false;
    await Promise.all([
      getFirmwareList(0, motorInfo.value),
      getFirmwareList(1, motorInfo.value)
    ]);
    return false;
  }
}

// 从infoData中提取所需的属性值（支持数组和对象类型）
function getInfoValue(key) {
  // 检查infoData是否为数组（电机）
  if (Array.isArray(motorInfo.value)) {
    const item = motorInfo.value.find(item => item.key === key);
    return item ? item.value : '';
  }
  // 如果是对象（仪表），直接返回对应属性值
  return motorInfo.value && motorInfo.value[key] ? motorInfo.value[key] : '';
}

// 处理序列号升级文件数据（直接使用已有数据，避免重复调用接口）
function processSerialNumberUpgradeFiles(data) {
  
  if (data) {
    
    // 处理返回数据 - 从数组中获取第一个元素
    const dataItem = Array.isArray(data) && data.length > 0 ? data[0] : data;

    let firmwareOptions = [];
    let configOptions = [];

    // 处理固件文件
    if (dataItem && (dataItem.firmware_file || dataItem.firmware_file_url)) {
      const firmwareFileName = dataItem.firmware_file_name || (dataItem.firmware_file_url?.split('/').pop() || 'firmware.bin');
      const firmwareFileUrl = dataItem.firmware_file_url || dataItem.firmware_file;
      const firmwareFileSize = dataItem.firmware_file_size || 0;

      // 发送downloadfile指令
      if (!downloadFileFailed.value) {
        wsSend('downloadfile', {
          p1: firmwareFileName,
          p2: firmwareFileUrl,
          p3: firmwareFileSize
        });
      }

      // 构建options项
      const option = {
        label: dataItem.name || '序列号固件',
        value: wsPath + '\\' + firmwareFileName,
        id: dataItem.id || '',
        fileName: firmwareFileName,
        key: dataItem.firmware_file || ''
      };
      firmwareOptions.push(option);
    }

    // 处理配置文件
    if (dataItem && (dataItem.params_file || dataItem.params_file_url)) {
      const configFileName = dataItem.params_file_name || (dataItem.params_file_url?.split('/').pop() || 'config.bin');
      const configFileUrl = dataItem.params_file_url || dataItem.params_file;
      const configFileSize = dataItem.params_file_size || 0;
      const serverParameterVersion = dataItem.config_version || '';
      
      // 获取当前设备的参数版本
      const currentParameterVersion = getInfoValue('parameterversion') || '';
      
      // 只有当服务器版本大于当前设备版本时，才添加到升级选项中
      if (currentParameterVersion && serverParameterVersion) {
        const compareResult = compareversions(serverParameterVersion, currentParameterVersion);
        
        if (compareResult > 0) {
          // 发送downloadfile指令
          if (!downloadFileFailed.value) {
            wsSend('downloadfile', {
              p1: configFileName,
              p2: configFileUrl,
              p3: configFileSize
            });
          }

          // 构建options项
          const option = {
            label: dataItem.name || '序列号配置',
            value: wsPath + '\\' + configFileName,
            id: dataItem.id || '',
            fileName: configFileName,
            key: dataItem.params_file || '',
            config_version: serverParameterVersion
          };
          configOptions.push(option);
        }
      }
    }

    // 更新uploadFiles和lastFile变量
    if (firmwareOptions.length > 0) {
      // 按id降序排序，取id最大的一条
      firmwareOptions.sort((a, b) => b.id - a.id);
      uploadFiles.value.firmware.options = firmwareOptions;
      uploadFiles.value.firmware.fileName = firmwareOptions[0].fileName;
      motorLastFirmwareFile.value = firmwareOptions[0].fileName;
    }

    if (configOptions.length > 0) {
      // 按id降序排序，取id最大的一条
      configOptions.sort((a, b) => b.id - a.id);
      uploadFiles.value.config.options = configOptions;
      uploadFiles.value.config.fileName = configOptions[0].fileName;
      motorLastConfigFile.value = configOptions[0].fileName;
    }

    // 标记用户类型为P8
    userType.value = 'P8';
  }
}



// 移除不再使用的临时变量
// const motorFirmwareOptions = ref([])
// const motorConfigOptions = ref([])
// const displayFirmwareOptions = ref([])

// 获取自动升级文件列表
function getFirmwareList(type, infoData) {
  return new Promise((resolve) => {
    const organizationId = localStorage.getItem('organizationId')
    
    // 从infoData中提取所需的属性值（支持数组和对象类型）
    function getLocalInfoValue(key) {
      // 检查infoData是否为数组（电机）
      if (Array.isArray(infoData)) {
        const item = infoData.find(item => item.key === key);
        return item ? item.value : '';
      }
      // 如果是对象（仪表），直接返回对应属性值
      return infoData && infoData[key] ? infoData[key] : '';
    }
    
    var params = {
      type: type,
      organization_id: organizationId,
      hardware_version: getLocalInfoValue('hardwareversion') || '',
    }
    
    // 保存productType值，用于后续构建options对象
    let productTypeValue = 0;
    
    // 获取当前设备的完整版本号
    const currentFullVersion = getLocalInfoValue('softwareversion') || '';
    
    if (type === 0) {
      params.firmware_version = currentFullVersion ? currentFullVersion.substr(0, 6) : ''
      params.productType = 0
      productTypeValue = 0;
    }
    if (type === 1) {
      params.config_version = getLocalInfoValue('parameterversion') || ''
      params.productType = 0
      productTypeValue = 0;
      // 如果参数版本为空，不进行后续处理
      if (!params.config_version) {
        // 清空参数文件选项
        uploadFiles.value.config.options = [];
        motorLastConfigFile.value = '';
        resolve(false);
        return;
      }
    }
    if (type === 2) {
      // 仪表固件查询
      params.firmware_version = currentFullVersion ? currentFullVersion.substr(0, 4) : ''
      params.productType = 1
      productTypeValue = 1;
      params.code = getLocalInfoValue('code') || '' // 添加产品型号参数
    }
    if (type === 3) {
      // 盒子固件查询
      params.firmware_version = currentFullVersion ? currentFullVersion.substr(0, 4) : ''
      params.productType = 3
      productTypeValue = 3;
      params.code = getLocalInfoValue('code') || '' // 添加产品型号参数
    }
    
    api.firmwareList(params).then(res => {
      if (res?.code !== 0) {
        resolve(false);
        return
      }
      
      // 过滤并处理服务器返回的固件列表
      let options = res?.data.map(item => {
        // 从productModels数组中提取硬件版本和固件版本信息
        const hardwareVersion = item.productModels ? item.productModels[0]?.hardware_version : undefined;
        const firmwareVersion = item.productModels ? item.productModels[0]?.software_version : undefined;
        // 提取参数版本信息（针对参数文件）
        const configVersion = item.productModels ? item.productModels[0]?.config_version : undefined;
        
        // 下载文件
        if (!downloadFileFailed.value) {
          wsSend('downloadfile', {
            p1: item.file_name,
            p2: item.file_url,
            p3: item.file_size
          })
        }
        
        return {
          label: item.name,
          value: wsPath + '\\' + item.file_name,
          id: item.id,
          fileName: item.file_name,
          key: item.file,
          hardware_version: hardwareVersion,
          firmware_version: firmwareVersion,
          config_version: configVersion, // 参数版本信息
          productType: productTypeValue // 使用调用API时设置的productType值
        }
      }).filter(option => {
        // 版本比较逻辑：只有当服务器版本大于当前设备版本时，才添加到升级选项中
        
        if (type === 1) { // 参数文件特殊处理
          // 获取当前参数版本
          const currentParameterVersion = getLocalInfoValue('parameterversion') || '';
          // 获取服务器返回的参数版本
          const serverParameterVersion = option.config_version || '';
          
          // 如果缺少版本信息，默认不显示
          if (!currentParameterVersion || !serverParameterVersion) {
            return false;
          }
          
          // 使用compareversions函数进行比较，只有服务器版本大于当前版本时才显示
          const compareResult = compareversions(serverParameterVersion, currentParameterVersion);
          
          return compareResult > 0;
        } else {
          // 固件文件处理（电机和仪表）
          if (!option.firmware_version || !currentFullVersion) {
            // 如果缺少版本信息，默认不显示
            return false;
          }
          
          if (type === 2) { // 仪表特殊处理
            // 确保版本号格式正确
            if (option.firmware_version.length !== 6 || currentFullVersion.length !== 6) {
              return false;
            }
            
            // 前4位必须相同，后2位服务器版本必须大于当前版本
            const serverPrefix = option.firmware_version.substr(0, 4);
            const currentPrefix = currentFullVersion.substr(0, 4);
            const serverSuffix = parseInt(option.firmware_version.substr(4, 2));
            const currentSuffix = parseInt(currentFullVersion.substr(4, 2));
            
            return serverPrefix === currentPrefix && serverSuffix > currentSuffix;
          } else if (type === 0) { // 电机固件
            // 使用compareversions函数进行比较
            const result = compareversions(option.firmware_version, currentFullVersion);
            return result > 0;
          } else if (type === 3) { // 盒子固件
            // 使用compareversions函数进行比较
            const result = compareversions(option.firmware_version, currentFullVersion);
            return result > 0;
          }
        }
        
        return false; // 默认不显示
      })
      
      // 按版本号降序排序，确保最新版本在最前面
      options.sort((a, b) => {
        if (a.firmware_version && b.firmware_version) {
          return compareversions(b.firmware_version, a.firmware_version);
        }
        return 0;
      })
      
      // 根据文件类型保存文件信息并显示在下拉框中
        if (type === 0) { //motor firmware
          // 按id降序排序，取id最大的一条
          options.sort((a, b) => b.id - a.id);
          // 如果有匹配的文件，只保留id最大的那个文件
          if (options.length > 0) {
            motorLastFirmwareFile.value = options[0].fileName;
            // 只显示id最大的那个文件
            uploadFiles.value.firmware.options = [options[0]];
            resolve(true);
          } else {
            // 如果没有符合条件的固件，清空下拉框
            uploadFiles.value.firmware.options = [];
            uploadFiles.value.firmware.fileName = '';
            resolve(false);
          }
        }
        if (type === 1) { //motor config
          // 按id降序排序，取id最大的一条
          options.sort((a, b) => b.id - a.id);
          // 如果有匹配的文件，只保留id最大的那个文件
          if (options.length > 0) {
            motorLastConfigFile.value = options[0].fileName;
            // 只显示id最大的那个文件
            uploadFiles.value.config.options = [options[0]];
            resolve(true);
          } else {
            // 如果没有符合条件的参数文件，清空下拉框
            uploadFiles.value.config.options = [];
            uploadFiles.value.config.fileName = '';
            resolve(false);
          }
        }
        if (type === 2) { //display firmware
          // 按id降序排序，取id最大的一条
          options.sort((a, b) => b.id - a.id);
          // 如果有匹配的文件，只保留id最大的那个文件
          if (options.length > 0) {
            displayLastFirmwareFile.value = options[0].fileName;
            // 只显示id最大的那个文件
            displayUploadFiles.value.firmware.options = [options[0]];
            resolve(true);
          } else {
            // 如果没有符合条件的固件，清空下拉框
            displayUploadFiles.value.firmware.options = [];
            displayUploadFiles.value.firmware.fileName = '';
            displayLastFirmwareFile.value = '';
            resolve(false);
          }
        }
        if (type === 3) { //box firmware
          // 按id降序排序，取id最大的一条
          options.sort((a, b) => b.id - a.id);
          // 如果有匹配的文件，只保留id最大的那个文件
          if (options.length > 0) {
            boxLastFirmwareFile.value = options[0].fileName;
            // 只显示id最大的那个文件
            boxUploadFiles.value.firmware.options = [options[0]];
            resolve(true);
          } else {
            // 如果没有符合条件的固件，清空下拉框
            boxUploadFiles.value.firmware.options = [];
            boxUploadFiles.value.firmware.fileName = '';
            boxLastFirmwareFile.value = '';
            resolve(false);
          }
        }
    }).catch(() => {
      resolve(false);
    })
  });
}

function upgradeCancel() {
  cancelLoading.value = true
  wsSend('UpdateDevice_Cancel', { devicetype: '', p1: '', p2: '' })
  // 取消升级后重置用户类型
  userType.value = '';
}

async function checkUpgrade(firmwareFile, configFile, type) {

  // 不要重置用户类型，让checkUpgradeForP8函数自然设置P8类型
  // 只有通过点击检查按钮升级，才有可能是P8类型
  
  // 用户点击升级提示弹窗后，设置默认选择的文件
  if (type === 'motor') {
    uploadFiles.value.firmware.fileName = firmwareFile
    uploadFiles.value.config.fileName = configFile
  }
  if (type === 'display') {
    displayUploadFiles.value.firmware.fileName = firmwareFile
  }
  if (type === 'battery') {
    batteryUploadFiles.value.firmware.fileName = firmwareFile
  }
  if (type === 'box') {
    boxUploadFiles.value.firmware.fileName = firmwareFile
  }

  // 直接执行升级流程，避免再次调用auto-upgrades接口
  // 注意：序列号升级文件检查已经在设备连接时（WebSocket初始化过程中）完成
  upgrade(type);
}

function clearSelectFile(code,key){
  // 清除选中文件时重置用户类型
  userType.value = '';
  
  // 如果没有提供key参数，则清除该设备类型的所有文件
  if (!key) {
    if(code === 'motor') {
      for (let k in uploadFiles.value) {
        uploadFiles.value[k].fileUrl = ''
        uploadFiles.value[k].key = ''
        uploadFiles.value[k].fileName = ''
      }
    } else if(code === 'display') {
      for (let k in displayUploadFiles.value) {
        displayUploadFiles.value[k].fileUrl = ''
        displayUploadFiles.value[k].key = ''
        displayUploadFiles.value[k].fileName = ''
      }
    } else if(code === 'battery') {
      for (let k in batteryUploadFiles.value) {
        batteryUploadFiles.value[k].fileUrl = ''
        batteryUploadFiles.value[k].key = ''
        batteryUploadFiles.value[k].fileName = ''
      }
    } else if(code === 'box') {
      for (let k in boxUploadFiles.value) {
        boxUploadFiles.value[k].fileUrl = ''
        boxUploadFiles.value[k].key = ''
        boxUploadFiles.value[k].fileName = ''
      }
    }
    return;
  }
  
  // 有key参数时，清除特定文件
  if(code === 'motor') {
    uploadFiles.value[key].fileUrl = ''
    uploadFiles.value[key].key = ''
  }
  if(code === 'display') {
    displayUploadFiles.value[key].fileUrl = ''
    displayUploadFiles.value[key].key = ''
  }
  if(code === 'battery') {
    batteryUploadFiles.value[key].fileUrl = ''
    batteryUploadFiles.value[key].key = ''
  }
  if(code === 'box') {
    boxUploadFiles.value[key].fileUrl = ''
    boxUploadFiles.value[key].key = ''
  }
}

// 获取用户升级次数信息
async function getUserUpgradeCountInfo() {
  try {
    // 直接从info接口获取用户信息
    const res = await getUserPermissions()

    if (res.code === 0) {
      // 使用info接口返回的id和diff_upgrade_count，但不设置默认upgradeType
      upgradeCountInfo.value = {
        userId: res.info.id || '',
        remainingCount: res.info.diff_upgrade_count || 0,
        upgradeType: 0 // 默认为0，等待WebSocket返回正确的值
      }
      // 当剩余次数为0时显示申请按钮
      showApplyButton.value = upgradeCountInfo.value.remainingCount === 0
      // 不标记为已加载，等待WebSocket返回upgradeType后再标记
      // upgradeCountLoaded.value = true
    }
  } catch (error) {
    console.error('获取升级次数信息失败:', error)
    // 即使失败也不标记为已加载，等待WebSocket返回upgradeType数据
    // upgradeCountLoaded.value = true
  }
}

// 申请升级次数
async function handleApplyUpgradeCount(applyData) {
  try {
    applyLoading.value = true

    const res = await applyUpgradeCount(applyData)

    if (res.code === 0) {
      ElMessage.success(t('ProductUpgrade.applySuccess'))
      // 重新获取升级次数信息
      await getUserUpgradeCountInfo()
    } else {
      ElMessage.error(res.message || t('ProductUpgrade.applyFailed'))
    }
  } catch (error) {
    console.error('申请升级次数失败:', error)
    ElMessage.error(t('ProductUpgrade.applyFailed'))
  } finally {
    applyLoading.value = false
  }
}

// 更新用户升级信息
async function updateUserUpgradeInfo(userId, remainingCount, upgradeType) {
  try {
    // 获取当前用户类型
    const currentUserType = userType.value || 'normal';
    
    // 确保remainingCount是整数类型
    remainingCount = parseInt(remainingCount) || 0;
    
    // 只有当upgradeType为1时，才调用后端接口修改次数
    if (upgradeType === 1) {

      // 使用api.js中的updateUserInfo函数
      const res = await api.updateUserInfo({
        diff_upgrade_count: remainingCount
      })

      // 只有当接口返回成功时，才更新本地状态
      if (res.code === 0) {
        // 更新本地状态
        upgradeCountInfo.value.userId = userId
        upgradeCountInfo.value.remainingCount = remainingCount
        upgradeCountInfo.value.upgradeType = upgradeType
        // 更新申请按钮显示状态
        showApplyButton.value = remainingCount === 0
        // 只有用户类型为normal时，才显示升级次数信息
        upgradeCountLoaded.value = currentUserType === 'normal'
      } else {
        // 接口返回非成功状态时，打印错误信息到控制台
        console.error('更新用户升级次数失败:', res.message || '未知错误')
      }
    } else {
      // 当upgradeType为0或2时，只更新本地状态，不调用后端接口
      upgradeCountInfo.value.userId = userId
      upgradeCountInfo.value.remainingCount = remainingCount
      upgradeCountInfo.value.upgradeType = upgradeType
      showApplyButton.value = remainingCount === 0
      // 当upgradeType不为1时，不显示升级次数信息
      upgradeCountLoaded.value = false
    }
  } catch (error) {
    console.error('更新升级信息失败:', error)
  }
}
</script>